import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "rightWrap"
};
const _hoisted_2 = {
  class: "titlebox"
};
const _hoisted_3 = {
  class: "contentwrap"
};
const _hoisted_4 = {
  id: "routemap",
  ref: "routemap",
  class: "routemap"
};
const _hoisted_5 = {
  class: "item dragliitem"
};
const _hoisted_6 = {
  class: "sortindex"
};
const _hoisted_7 = {
  class: "toolbox"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "searchcontent"
};
const _hoisted_10 = {
  class: "searchwrap"
};
const _hoisted_11 = {
  class: "list"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  class: "bottombutton"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_Sort = _resolveComponent("Sort");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_input_number = _resolveComponent("el-input-number");
  const _component_draggable = _resolveComponent("draggable");
  const _component_Search = _resolveComponent("Search");
  const _component_CircleCloseFilled = _resolveComponent("CircleCloseFilled");
  const _component_el_form = _resolveComponent("el-form");
  const _component_CaretBottom = _resolveComponent("CaretBottom");
  const _component_CaretRight = _resolveComponent("CaretRight");
  const _component_drawlinestyle = _resolveComponent("drawlinestyle");
  const _component_el_collapse_item = _resolveComponent("el-collapse-item");
  const _component_el_collapse = _resolveComponent("el-collapse");
  const _component_el_button = _resolveComponent("el-button");
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString($props.isadd ? '添加' : '编辑') + "路线", 1), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_form, {
    ref: "formdata",
    model: $props.form
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      label: $props.formlabel.title,
      prop: "title",
      rules: [{
        required: true,
        message: `请填写${$props.formlabel.title}`
      }]
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $props.form.title,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $props.form.title = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label", "rules"]), _createVNode(_component_el_form_item, {
      label: $props.formlabel.type,
      prop: "type",
      rules: [{
        required: true,
        message: `请选择${$props.formlabel.type}`,
        trigger: 'blur'
      }]
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        modelValue: $props.form.type,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $props.form.type = $event),
        placeholder: "请选择"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.typelist, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.id,
            label: item.itemformdata.title,
            value: item.itemformdata.onlyid
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label", "rules"]), _createElementVNode("div", _hoisted_4, null, 512), _createVNode(_component_el_form_item, {
      label: $props.formlabel.jsontxt,
      prop: "jsontxt",
      rules: [{
        required: true,
        message: `请制作${$props.formlabel.jsontxt}`,
        trigger: 'blur'
      }]
    }, {
      default: _withCtx(() => [_createVNode(_component_draggable, {
        class: "dragitem",
        list: $data.routePointList,
        handle: ".mover",
        itemKey: "index",
        "ghost-class": "ghostdragliitem",
        "chosen-class": "ghostdragliitem",
        onEnd: $options.onEnd
      }, {
        item: _withCtx(({
          element,
          index
        }) => [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString(index + 1), 1), _createElementVNode("h4", null, _toDisplayString(element.itemformdata.place_name), 1), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_icon, {
          class: "icon mover"
        }, {
          default: _withCtx(() => [_createVNode(_component_Sort)]),
          _: 1
        }), _createElementVNode("i", {
          class: "icon icon-delete",
          onClick: $event => $options.deleteroute(index)
        }, null, 8, _hoisted_8)]), _createVNode(_component_el_input_number, {
          modelValue: element.itemformdata.speed,
          "onUpdate:modelValue": $event => element.itemformdata.speed = $event,
          precision: 1,
          step: 0.5,
          min: 0.5,
          max: 100,
          size: "small",
          "controls-position": "right",
          onChange: $event => $options.routeSpeedChange($event, element)
        }, {
          prefix: _withCtx(() => _cache[7] || (_cache[7] = [_createElementVNode("span", null, "运动时间", -1)])),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])])]),
        _: 1
      }, 8, ["list", "onEnd"]), _createElementVNode("div", {
        class: _normalizeClass(["searchpointbox", {
          'hasroute': $data.routePointList.length > 0
        }])
      }, [_createElementVNode("div", {
        class: "headerbox",
        onClick: _cache[2] || (_cache[2] = $event => $data.searchflag = !$data.searchflag)
      }, _cache[8] || (_cache[8] = [_createElementVNode("img", {
        src: "https://p.ananas.chaoxing.com/star3/origin/084f9b370761f656ba49a20286ee0648.png",
        alt: ""
      }, null, -1), _createElementVNode("span", null, "选择一个点位", -1)])), _withDirectives(_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_Search)]),
        _: 1
      }), _withDirectives(_createVNode(_component_el_icon, {
        class: "close",
        onClick: _cache[3] || (_cache[3] = $event => $data.searchKey = '')
      }, {
        default: _withCtx(() => [_createVNode(_component_CircleCloseFilled)]),
        _: 1
      }, 512), [[_vShow, $data.searchKey !== '']]), _createVNode(_component_el_input, {
        modelValue: $data.searchKey,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.searchKey = $event),
        placeholder: "搜索"
      }, null, 8, ["modelValue"])]), _createElementVNode("ul", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.staticpointlist, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index,
          onClick: $event => $options.pointclick(item)
        }, _toDisplayString(item.itemformdata.place_name), 9, _hoisted_12);
      }), 128))])], 512), [[_vShow, $data.searchflag]])], 2)]),
      _: 1
    }, 8, ["label", "rules"]), _createVNode(_component_el_form_item, {
      class: "topbottom",
      label: $props.formlabel.introduce,
      prop: "introduce"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $props.form.introduce,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $props.form.introduce = $event),
        style: {
          "width": "100%"
        },
        autosize: {
          minRows: 5,
          maxRows: 8
        },
        type: "textarea"
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"])]),
    _: 1
  }, 8, ["model"])]), _createVNode(_component_el_collapse, {
    class: "routecollapse",
    modelValue: $data.linestyleValue,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.linestyleValue = $event),
    onChange: $options.lienstylehandleChange,
    accordion: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_el_collapse_item, {
      name: "1"
    }, {
      title: _withCtx(() => [_withDirectives(_createVNode(_component_el_icon, {
        class: "icon-bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
        _: 1
      }, 512), [[_vShow, !$data.flag1]]), _withDirectives(_createVNode(_component_el_icon, {
        class: "icon-right"
      }, {
        default: _withCtx(() => [_createVNode(_component_CaretRight)]),
        _: 1
      }, 512), [[_vShow, $data.flag1]]), _cache[9] || (_cache[9] = _createElementVNode("span", null, "路线样式", -1))]),
      default: _withCtx(() => [_createVNode(_component_drawlinestyle, {
        value: $data.linestyle,
        onLinestyleback: $options.linestyleHandle
      }, null, 8, ["value", "onLinestyleback"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue", "onChange"]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_el_button, {
    plain: "",
    onClick: $options.routeclose
  }, {
    default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode("取消")])),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    type: "primary",
    plain: "",
    onClick: $options.submitHandle
  }, {
    default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode("确认")])),
    _: 1
  }, 8, ["onClick"])])], 512)), [[_vShow, $data.routeShow]]);
}